import { NextPage, GetServerSideProps } from "next";
import Head from "next/head";
// Components
import { MobileWeb } from "../../components/templates";
import { AboutContent } from "../../components/organisms";

interface AboutPageProps {
  query: any;
}

const About: NextPage<AboutPageProps> = (props: AboutPageProps) => {
  const { query } = props;

  const { layout } = query;

  return (
    <MobileWeb>
      {/* SEO */}
      <Head>
        <title>Foodizmart: About</title>
        <meta name="description" content="Generated by create next app" />
      </Head>

      {/* Content */}
      <section className="py-4 osahan-main-body" style={{ minHeight: layout === "mobile" ? 300 : 700 }}>
        <div className="container">

          <AboutContent query={query} />

        </div>
      </section>
    </MobileWeb>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, query } = context;

  return { props: { query } };
};

export default About;
